// store/middleware/bonusCacheMiddleware.ts
import { Middleware } from '@reduxjs/toolkit'
import { saveToStorage } from '../../common/utils/functions/localStorage'
import { getCacheVersion } from '../../config/runtimeConfig'

export const bonusCacheMiddleware: Middleware = (store) => (next) => (action: any) => {
  const result = next(action)

  if (action.type === 'bonus/setBonusData') {
    const bonusData = store.getState().bonus.data

    if (bonusData) {
      try {
        const version = getCacheVersion()
        const CACHE_KEY = `bonus_balance_v${version}`
        saveToStorage(CACHE_KEY, bonusData)
      } catch (error) {
        console.error('Ошибка сохранения кэша бонусов:', error)
      }
    }
  }

  return result
}